module.exports = __webpack_public_path__ + "img/ballroller.54d68c7d.jpg";